import React, { useState, useEffect } from 'react';

export const AdminUsers = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [clientId, setClientId] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [isMasterClient, setIsMasterClient] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const [vendorList, setVendorList] = useState([]);
  const [clientSearch, setClientSearch] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  useEffect(() => {
    fetch('/apivendorlist', { credentials: 'include' })
      .then(res => res.ok ? res.json() : [])
      .then(data => setVendorList(data));
  });

  const filteredVendors = vendorList.filter(client => {
    if (!clientSearch) return true;
    const term = clientSearch.toLowerCase();
    const code = client[17] ? client[17].value.toLowerCase() : '';
    const name = client[13] ? client[13].value.toLowerCase() : '';
    const address = client[7] ? client[7].value.toLowerCase() : '';
    return code.includes(term) || name.includes(term) || address.includes(term);
  });

  const handleClientSelect = (client) => {
    setSelectedClient(client);
    setClientId(client[3] ? client[3].value : '');
    setClientSearch('');
    setShowDropdown(false);
  };

  const handleClearClient = () => {
    setSelectedClient(null);
    setClientId('');
  };

  const handleCreate = async () => {
    setMessage('');
    setError('');
    if (!email || !password) {
      setError('Email and password are required');
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }
    try {
      const res = await fetch('/apiadmin/createUser', { credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, client_id: clientId || null, is_admin: isAdmin, is_master_client: isMasterClient })
      });
      if (!res.ok) {
        const data = await res.json();
        setError(data.message || 'Failed to create user');
        return;
      }
      await res.json();
      setMessage(`User "${email}" created successfully`);
      setEmail('');
      setPassword('');
      setClientId('');
      setIsAdmin(false);
      setIsMasterClient(false);
      setSelectedClient(null);
      setClientSearch('');
    } catch (err) {
      setError('Server error');
    }
  };

  return (
    <div className="locations">
      <div className="locationsList">
        <h2>Create User</h2>
        <div className="signupInputsWrapper" style={{ maxWidth: '400px' }}>
          <input placeholder="Email" className="inputAuth" value={email} onChange={e => setEmail(e.target.value)} />
          <input placeholder="Temporary Password" type="password" className="inputAuth" value={password} onChange={e => setPassword(e.target.value)} />

          <div style={{ position: 'relative' }}>
            {selectedClient ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px', border: '1px solid #ccc', borderRadius: '4px', background: '#f9f9f9', fontSize: '14px' }}>
                <span style={{ fontWeight: 'bold', minWidth: '50px' }}>{selectedClient[15] ? selectedClient[15].value : ''}</span>
                <span style={{ flex: 1, textAlign: 'center', padding: '0 8px' }}>{selectedClient[6] ? selectedClient[6].value : ''}</span>
                <button onClick={handleClearClient} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#999', fontSize: '16px', padding: '0' }}>✕</button>
              </div>
            ) : (
              <input
                placeholder="Search vendors..."
                className="inputAuth"
                value={clientSearch}
                disabled={isAdmin}
                onFocus={() => setShowDropdown(true)}
                onChange={e => { setClientSearch(e.target.value); setShowDropdown(true); }}
                onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
              />
            )}
            {showDropdown && !isAdmin && !selectedClient && (
              <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc', borderRadius: '0 0 4px 4px', background: 'white', zIndex: 10 }}>
                {filteredVendors.map((client, idx) => (
                  <div
                    key={idx}
                    onMouseDown={() => handleClientSelect(client)}
                    style={{ display: 'flex', alignItems: 'center', padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #eee', fontSize: '14px' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f0f0f0'}
                    onMouseLeave={e => e.currentTarget.style.background = 'white'}
                  >
                    <span style={{ fontWeight: 'bold', minWidth: '60px' }}>{client[13] ? client[13].value : ''}</span>
                    <span style={{ flex: 1, textAlign: 'center' }}>{client[17] ? client[17].value : ''}</span>
                    {/* <span style={{ flex: 1, textAlign: 'center' }}>{client[6] ? client[6].value : ''}</span> */}
                    <span style={{ color: '#666', minWidth: '100px', textAlign: 'right', fontSize: '12px' }}>{client[6] ? client[6].value : ''}</span>
                  </div>
                ))}
                {filteredVendors.length === 0 && <div style={{ padding: '8px 12px', color: '#999', fontSize: '14px' }}>No clients found</div>}
              </div>
            )}
          </div>

          {(() => {
            const checkboxRowStyle = (checked, disabled) => ({
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 16px',
              margin: '8px 0',
              border: `1px solid ${checked ? '#B7966A' : '#d0d4d8'}`,
              borderRadius: '8px',
              background: checked ? '#eef2f8' : 'white',
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.5 : 1,
              fontSize: '15px',
              fontWeight: 500,
              color: '#222',
              transition: 'background 120ms ease, border-color 120ms ease',
              userSelect: 'none',
            });
            const checkboxStyle = { width: '20px', height: '20px', accentColor: '#B7966A', cursor: 'inherit', flexShrink: 0 };
            return (
              <>
                <label style={checkboxRowStyle(isAdmin, !!clientId)}>
                  <input
                    type="checkbox"
                    checked={isAdmin}
                    disabled={!!clientId}
                    onChange={e => { setIsAdmin(e.target.checked); if (e.target.checked) { setSelectedClient(null); setClientId(''); setClientSearch(''); setIsMasterClient(false); } }}
                    style={checkboxStyle}
                  />
                  Admin
                </label>
                {/* <label style={checkboxRowStyle(isMasterClient, isAdmin)}>
                  <input
                    type="checkbox"
                    checked={isMasterClient}
                    disabled={isAdmin}
                    onChange={e => {
                      setIsMasterClient(e.target.checked);
                      setSelectedClient(null);
                      setClientId('');
                      setClientSearch('');
                    }}
                    style={checkboxStyle}
                  />
                  Is a master client
                </label> */}
              </>
            );
          })()}
          {error && <p style={{ color: '#e74c3c', fontSize: '14px', margin: '8px 0 0' }}>{error}</p>}
          {message && <p style={{ color: '#27ae60', fontSize: '14px', margin: '8px 0 0' }}>{message}</p>}
          <button className="mainButton loginButton" onClick={handleCreate}>Create User</button>
        </div>
      </div>
    </div>
  );
};
